import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as TrackingToolFromEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor";
import { Route as TrackingToolFromGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/"
)({
    component: TrackingToolFromDetailPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingIncomingEditGeneral, PermissionEnum.ToolTrackingIncomingEditEditor],
        showInSideMenu: false,
        label: "pages.tool.tracking.from.general.title",
        redirects: [TrackingToolFromGeneralPage, TrackingToolFromEditorPage],
        defaultRedirect: TrackingToolFromGeneralPage,
    },
});

function TrackingToolFromDetailPage() {
    return <RedirectPage />;
}
